import React from 'react';
import GeneralSVG from "../../generalSVG";
import Button from "../../button";
import FormResponseMessage from "../../formResponseMessage";
import { FormGroup } from 'arag-ui-lib';

const Step3 = (props) => {
    if(props.currentStep !== 3)
        return null;
    return (
        <div>
            {
                props.openSolicitorModal ?
                    <div className="solicitorGroupList-modal">
                        <div className="premiumSettingsWizard-modal-content">
                            <div className="appFormRefSettings-close-button"
                                onClick={() => {
                                    props.changeStoreSettings('openSolicitorModal', false);
                                    props.changeLawsysFirmState('suggestionFieldValue', '');
                                    props.changeLawsysFirmState('selectedLawsysFirmsDropdown',[]);
                                    props.changeLawsysFirmState('lawsysFirmsFiltered', []);
                                }}>
                            </div>
                            <FormGroup 
                                labelSize={"col-xs-3"}
                                inputSize={"col-xs-7"}
                                label={`Agent`}
                                variant={"searchableList"}
                                inputProps={{
                                    inputValue: props.lawsysFirms.suggestionFieldValue,
                                    onInputChange: props.onSuggestionChange,
                                    instanceId: 'agent',
                                    value: props.lawsysFirms.selectedLawsysFirmsDropdown.length > 0 
                                        ? props.lawsysFirms.selectedLawsysFirmsDropdown.map(l => ({value: l.id, label: l.name}))[0]
                                        : null,
                                    onChange: (value) => props.onSuggestionSelected(value),
                                    options: props.lawsysFirms.lawsysFirmsFiltered.filter(x => props.solicitorsList.some(s => s.id === x.id) === false)
                                                                                  .map(l => ({value: l.id, label: l.name})),
                                    isLoading: props.lawsysFirms.fetching,
                                    placeholder: 'Type at least 3 letters',
                                    noOptionsText: `No Agents found`,
                                    minSearchCharacters: 3,
                                    isMulti: false,
                                }}
                            />
                            <Button
                                clickHandler={() => {
                                    props.addSolicitor()
                                } }
                                wrapper="btn-wrapper-forForms"
                                btnType="button"
                                btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                label="Add To Commission List"
                                disabled={props.lawsysFirms.selectedLawsysFirmsDropdown.length === 0}
                            />
                            <div onClick={() => {
                                props.changeStoreSettings('openSolicitorModal', false);
                                props.changeLawsysFirmState('suggestionFieldValue', '');
                                props.changeLawsysFirmState('selectedLawsysFirmsDropdown', []);
                                props.changeLawsysFirmState('lawsysFirmsFiltered', []);
                                }}>
                                <GeneralSVG
                                    SvgWrapper="generalTab-readMore-wrapper inlineBlock "
                                    Label="Cancel"
                                    Svg={<svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 9.6 16"><title>
                                        Asset
                                        2</title>
                                        <g id="Layer_2"
                                           data-name="Layer 2">
                                            <g id="Layer_1-2"
                                               data-name="Layer 1">
                                                <path
                                                    d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
                                            </g>
                                        </g>
                                    </svg>}
                                />
                            </div>
                        </div>
                    </div>
                    :
                    null
            }
            <p className="premiumSettingsWizard-step-message">{props.stepMessage}</p>
            <Button
                clickHandler={() => {
                    props.changeStoreSettings('openSolicitorModal', true);
                    props.changeLawsysFirmState('suggestionFieldValue', '');
                    props.changeLawsysFirmState('suggestions',[]);
                } }
                wrapper="btn-wrapper spacing"
                btnType="button"
                btnStyle={'btn btn-primary btn-xs sharp blue'}
                label="Add New Commission"
            />
            <table className="table table-striped">
                <thead className="table-head">
                <tr>
                    <th>Agent</th>
                </tr>
                </thead>
                <tbody className="appFormRefSettings-tbody">
                {
                    props.solicitorsList.map((list, index) => {
                        return <tr key={index}>
                            <td>{list.name}
                                <div className="displayRight" onClick={() => props.removeSolicitor(index)}>
                                    <GeneralSVG
                                        SvgWrapper="generalTab-readMore-wrapper inlineBlock "
                                        Label="Remove"
                                        Svg={<svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 9.6 16"><title>
                                            Asset
                                            2</title>
                                            <g id="Layer_2"
                                               data-name="Layer 2">
                                                <g id="Layer_1-2"
                                                   data-name="Layer 1">
                                                    <path
                                                        d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
                                                </g>
                                            </g>
                                        </svg>}
                                    />
                                </div>
                            </td>
                        </tr>
                    })
                }
                </tbody>
            </table>
            {
                props.step3WarningMsg !== '' && (props.solicitorsList.length === 0)?
                    <FormResponseMessage
                        LeftWrapper=""
                        CenterWrapper="col-sm-12"
                        MessageStyle="formResponseMessage-reject"
                        Message={props.step3WarningMsg}/>
                    :
                    null
            }
        </div>
    )
};

export default Step3;